import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { EmployeeRole } from "../../../user/employee/dto/role-type";
import { EmployeeDTO } from "../../../user/employee/dto/EmployeeDTO";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { ModalContainerComponent } from "../../../shared/component/modal-container/modal-container.component";
import { InputComponent } from "../../../shared/component/inputs/input-component/input.component";
import { SwitcherComponent } from "../../../shared/component/switcher/switcher.component";
import { AllIconsComponent } from "../../../shared/component/all-icons/all-icons.component";


@Component({
  selector: 'app-modal-team-member',
  templateUrl: './modal-team-member.component.html',
  styleUrls: ['./modal-team-member.component.scss'],
  imports: [
    ModalContainerComponent,
    ReactiveFormsModule,
    InputComponent,
    SwitcherComponent,
    AllIconsComponent,
  ],
})
export class ModalTeamMemberComponent implements OnInit {
  @Input() employee: EmployeeDTO;

  @Output() applyEmitter = new EventEmitter<EmployeeDTO>();
  @Output() cancelEmitter = new EventEmitter<void>();

  teamMemberForm: FormGroup<{
    email: FormControl<string>;
    isAbleToManageUsers: FormControl<boolean>;
  }>;

  spinnerProps = {
    isSpinnerActive: false,
    notActiveOnApply: true,
  };

  modalButtons = {
    dismiss: 'Cancel',
    apply: 'Apply',
  };

  ngOnInit(): void {
    this.initializeForm();
  }

  onApply(): void {
    if (this.teamMemberForm.valid) {
      const formValue = this.teamMemberForm.getRawValue();
      const employeeData: EmployeeDTO = {
        uuid: null,
        orgUUID: null,
        role: EmployeeRole.ADMIN,
        mail: formValue.email,
        isOrganizationAdmin: false,
        isAbleToManageUsers: formValue.isAbleToManageUsers,
      };
      this.applyEmitter.emit(employeeData);
    }
  }

  onCancel(): void {
    this.cancelEmitter.emit();
  }

  resetForm(): void {
    this.updateFormForMode();
  }

  private initializeForm(): void {
    this.teamMemberForm = new FormGroup({
      email: new FormControl('', {
        validators: [Validators.required, Validators.email],
        nonNullable: true,
      }),
      isAbleToManageUsers: new FormControl(false, { nonNullable: true }),
    });
  }

  private updateFormForMode(): void {
    this.teamMemberForm.reset({
      email: '',
      isAbleToManageUsers: false,
    });
    this.teamMemberForm.controls.email.enable();
  }
}
